// src/components/pages/Caixa/tabs/caixaTabPanel.jsx
import React from 'react';
import formStyles from '../../../form/Form.module.css';

import SelectEmpresa from '../../../form/SelectEmpresa';
import Input from '../../../form/Input';
import InputNumber from '../../../form/InputNumber';
import Checkbox from '../../../form/Checkbox';
import Select from '../../../form/Select';
import DataList from '../../../form/DataList';

/* utils */
import { formatarNumero } from '../../../../utils/masks';
import { retornaDataHora } from '../../../../utils/retornaDataFormatada';
import { podeConferir } from '../../../../hooks/usePermisionMRT';
const CaixaTabPanel = ({
    module,
    //parametros
    profile,
}) => {
    const { dados, optionsEmpresa, optionsSituacao, optionsContaCaixa, Colaborador, optionsColaborador, btnText } = module.state;
    const { change: onChange, focus: onFocus, blur: onBlur } = module.actions;

    const uiTab = profile?.uiTabs?.caixa;

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>
            <div>
                <SelectEmpresa
                    text="Selecione a Empresa"
                    name="empresaId"
                    options={optionsEmpresa}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.empresaId || ''}
                    required
                    notOptNull={true}
                />
                <Select
                    name="contaId"
                    title="Selecione a conta caixa"
                    text="Conta"
                    inputWidth="180px"
                    options={optionsContaCaixa}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.contaId}
                    isEnum={false}
                    notOptNull={false}
                />
                <Input
                    text="Data"
                    type="date"
                    name="data"
                    placeholder="Data"
                    title="Data"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.data}
                />

                {btnText !== 'Cadastrar' && (
                    <>
                        <Input
                            text="Número"
                            type="text"
                            name="contador"
                            inputWidth="80px"
                            placeholder="Número"
                            title={`Número do caixa`}
                            handleOnChange={onChange}
                            handleOnFocus={onFocus}
                            handleOnBlur={onBlur}
                            value={dados.contador || ''}
                            required={false}
                            readonly={true}
                            textAlign="center"
                        />
                    </>
                )}

                <Select
                    name="situacaoId"
                    title="Define a situação do movimento"
                    text="Situação"
                    inputWidth="170px"
                    options={optionsSituacao}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.situacaoId}
                    isEnum={false}
                    notOptNull={true}
                />
                <InputNumber
                    text="Troco"
                    type="text"
                    name="troco"
                    placeholder="Troco R$"
                    inputWidth="100px"
                    title="digite o valor de troco do caixa em R$ (reais)"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.troco ? formatarNumero(dados.troco) : ''}
                />
                <Checkbox
                    title="quando o caixa estiver fechado e devidamente conferido"
                    text="Conferido"
                    name="conferido"
                    handleOnChange={onChange}
                    value={dados.conferido}
                    checked={!!dados.conferido}
                    disabled={parseInt(dados.situacaoId) === 1 || !podeConferir()}
                />
                <Checkbox
                    title="Ativa quando marcado"
                    text="Ativo"
                    name="ativo"
                    handleOnChange={onChange}
                    value={dados.ativo}
                    checked={!!dados.ativo}
                />
            </div>
            <div>
                <DataList
                    text="Colaborador operador do caixa"
                    name="Colaborador.descricao"
                    placeholder={`Pesquise o colaborador operador do caixa`}
                    inputWidth="350px"
                    filteredOptions={optionsColaborador}
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={Colaborador?.descricao || ''}
                    required={true}
                />
                <Input
                    text="Abertura"
                    type="datetime-local"
                    name="abertura"
                    placeholder=""
                    title="momento de abertura do caixa"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.abertura && retornaDataHora(dados.abertura)}
                    inputWidth={'150px'}
                    readonly={parseInt(dados.situacaoId) !== 1}
                />
                <InputNumber
                    text="Saldo Abertura"
                    type="text"
                    name="saldoAbertura"
                    placeholder="Saldo R$"
                    inputWidth="150px"
                    title="digite o saldo da conta na abertura do caixa em R$ (reais)"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.saldoAbertura ? formatarNumero(dados.saldoAbertura) : ''}
                    readonly={parseInt(dados.situacaoId) !== 1}
                />
                <Input
                    text="Fechamento"
                    type="datetime-local"
                    name="fechamento"
                    placeholder=""
                    title="momento de fechamento do caixa"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.fechamento && retornaDataHora(dados.fechamento)}
                    inputWidth={'150px'}
                    readonly={parseInt(dados.situacaoId) === 1}
                />
                <InputNumber
                    text="Saldo Fechamento"
                    type="text"
                    name="saldoFechamento"
                    placeholder="Saldo R$"
                    inputWidth="150px"
                    title="digite o saldo da conta no fechamento do caixa em R$ (reais)"
                    handleOnChange={onChange}
                    handleOnFocus={onFocus}
                    handleOnBlur={onBlur}
                    value={dados.saldoFechamento ? formatarNumero(dados.saldoFechamento) : ''}
                />
            </div>
            <div>
                <InputNumber
                    text="Recebido no dia"
                    type="text"
                    name="totalRecebido"
                    placeholder="Reais R$"
                    inputWidth="150px"
                    title="valor total recebido no dia"
                    readonly={true}
                    value={dados.totalRecebido}
                />
                <InputNumber
                    text="Pago no dia"
                    type="text"
                    name="totalPago"
                    placeholder="Reais R$"
                    inputWidth="150px"
                    title="valor total pago no dia"
                    readonly={true}
                    value={dados.totalPago}
                />
                {dados.totaisPorForma &&
                    Object.entries(dados.totaisPorForma).map(([forma, valor]) => (
                        <InputNumber
                            text={forma}
                            type="text"
                            name={`forma_${forma}`}
                            placeholder="Reais R$"
                            inputWidth="150px"
                            title={`Total recebido em ${forma}`}
                            readonly={true}
                            value={formatarNumero(parseFloat(valor).toFixed(2))}
                        />
                    ))}
            </div>
        </div>
    );
};
export default React.memo(CaixaTabPanel);
